import { render, staticRenderFns } from "./InfoEditForm.vue?vue&type=template&id=81430c70&scoped=true&"
import script from "./InfoEditForm.vue?vue&type=script&lang=ts&"
export * from "./InfoEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./InfoEditForm.vue?vue&type=style&index=0&id=81430c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81430c70",
  null
  
)

export default component.exports